@if (hideMenuToggle() === false) {
  <button mat-icon-button (click)="toggleMenu()">
    <mat-icon>menu</mat-icon>
  </button>
}
<ng-content select="glxy-navigation-toolbar-left, [glxyNavigationToolbarLeft]" />
<div class="spacer"></div>
<ng-content select="glxy-navigation-toolbar-right, [glxyNavigationToolbarRight]" />
